import { render, staticRenderFns } from "./SearchUserById.vue?vue&type=template&id=ed424696"
import script from "./SearchUserById.vue?vue&type=script&lang=js"
export * from "./SearchUserById.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports